import React, { useState } from "react";
import { CognitoUser } from "amazon-cognito-identity-js";
import Pool from "./UserPool";
import "./style.css";
import { Placeholder } from "react-bootstrap";
import { Navigate } from "react-router-dom";
// import Rivazia from "../../Assets/images/blog.svg";
import { useNavigate } from "react-router-dom";
const Index = () => {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1); // 1 = email stage, 2 = code stage
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const getUser = () => {
    return new CognitoUser({
      Username: email.toLowerCase(),
      Pool,
    });
  };

  const sendCode = (event: any) => {
    event.preventDefault();

    getUser().forgotPassword({
      onSuccess: (data) => {
        console.log("onSuccess:", data);
      },
      onFailure: (err) => {
        console.error("onFailure:", err);
      },
      inputVerificationCode: (data) => {
        console.log("Input code:", data);
        setStage(2);
      },
    });
  };

  const resetPassword = (event: any) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      console.error("Passwords are not the same");
      return;
    }

    getUser().confirmPassword(code, password, {
      onSuccess: (data) => {
        console.log("onSuccess:", data);
        navigate("/");
      },
      onFailure: (err) => {
        console.error("onFailure:", err);
      },
    });
  };

  return (
    <div className="forget-password-container">
      <div className="otp-input-container">
        {stage === 1 && (
          <div className="d-flex flex-column border h-50 forget-password justify-content-center align-items-center">
            <div className="d-flex align-items-center justify-content-center login-index">
              Forget Password
            </div>
            {/* <p className="action-command">Enter your Email address</p> */}
            {/* <div className="forget-form"> */}
            <form onSubmit={sendCode} className="forget-form">
              <input
                className="forget-input"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Enter your Email address"
              />
              <button type="submit" className="btn-login">
                Send verification code
              </button>
            </form>
            {/* </div> */}
            <div className="login-image">
              {/* <img className="login-vector mt-2" src={Rivazia} alt="" /> */}
            </div>
          </div>
        )}

        {stage === 2 && (
          <div className="d-flex flex-column border h-75 forget-password justify-content-center align-items-center">
            <div className="d-flex align-items-center justify-content-center m-3 login-index">
              Reset Password
            </div>
            <form onSubmit={resetPassword}>
              <input
                className="forget-input"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                placeholder="Enter your OTP"
              />
              <input
                className="forget-input"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter your New Password"
              />
              <input
                className="forget-input"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                placeholder="Confirm your Password"
              />
              <button type="submit" className="btn-login">
                Change password
              </button>
            </form>
            <div className="login-image">
              {/* <img className="login-vector mt-2" src={loginVecotor} alt="" /> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
